import React from 'react';

const RoomAvailabilitySwitch = ({ status, canManage = true, onChange }) => <div>
  <label className="room-active-switch">
    <input type="checkbox" name="active" role="switch" aria-label="Active - Còn phòng" aria-checked={status === 'available'} checked={status === 'available'} disabled={!canManage} onChange={(event) => {
      if (canManage) onChange(event.target.checked ? 'available' : 'rented');
    }} />
    <span className="room-switch-track" aria-hidden="true"><span className="room-switch-thumb" /></span>
    {/* <span>{status === 'available' ? 'Active · Còn phòng' : 'Không active · Hết phòng (đã ẩn)'}</span> */}
  </label>
  <small className="room-availability-hint">{canManage ? (status === 'available' ? 'Phòng còn trống và đang hiển thị công khai. Tắt để ẩn phòng.' : 'Phòng hết và đã ẩn khỏi danh sách công khai. Bật để mở lại phòng.') : 'Chỉ quản trị viên và người đăng phòng được thay đổi trạng thái.'}</small>
</div>;

export default RoomAvailabilitySwitch;
